import React from 'react';
import { AccordionItem } from './AccordionItem';
type Props = {
  lines: Array<any>;
  children?: ComponentType;
  trackingEventName: string;
};
export const AccordionBlock = ({ trackingEventName, lines, children }: Props) => {
  return (
    <div>
      {lines.map((props, index) => {
        return (
          <AccordionItem
            key={index}
            {...props}
            trackingData={{
              ...props.trackingData,
              event: trackingEventName || props.trackingData.event,
            }}
          />
        );
      })}
      {children}
    </div>
  );
};
